import { createApp, reactive } from 'vue'

import Loading from './Loading.vue'

const msg = reactive({
    show: false,
    title: '加载中...'
})

const $loading = createApp(Loading, {msg}).mount(document.createElement('div'))
const load = {
    show(title) { // 控制显示loading的方法
        msg.show = true
        msg.title = title || '加载中...'
        document.body.appendChild($loading.$el)
    },

    hide() { // 控制loading隐藏的方法
        msg.show = false
    }
}

export default {
    install(app) {
        // Vue.prototype.$http = axios
        app.config.globalProperties.$loading = load
    }
}